import { render } from "./PendingOrganizationActivationCard.vue?vue&type=template&id=acf23f04"
import script from "./PendingOrganizationActivationCard.vue?vue&type=script&lang=js"
export * from "./PendingOrganizationActivationCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PendingOrganizationActivationCard.vue"]])

export default __exports__